import { useState } from "react";
import { Field, FormCard, ListState, post, useList, useSubmit, AC } from "./shared";

const fmtD = (d) => new Date(`${d}T00:00:00`).toLocaleDateString("id-ID", { day: "numeric", month: "long", year: "numeric" });

export const YearsTab = ({ canManage }) => {
  const q = useList(`${AC}/years`);
  const s = useSubmit();
  const ss = useSubmit();
  const [f, setF] = useState({ name: "", start_date: "", end_date: "" });
  const [sem, setSem] = useState({});
  const addYear = () => s.run(() => post("/years", f), "Tahun ajaran dibuat.").then((ok) => ok && setF({ name: "", start_date: "", end_date: "" }));
  const addSem = (y, name) => ss.run(() => post(`/years/${y.id}/semesters`, { name, ...sem[`${y.id}-${name}`] }), `Semester ${name} ditambahkan.`);
  const setSemF = (key, k, v) => setSem({ ...sem, [key]: { ...sem[key], [k]: v } });
  return (
    <div className="space-y-5">
      {canManage && (
        <FormCard title="Tambah tahun ajaran" onSubmit={addYear} busy={s.busy} err={s.err} submitLabel="Simpan" testId="year-form">
          <Field id="y-name" label="Nama (contoh 2026/2027)" value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} data-testid="year-name-input" />
          <Field id="y-start" label="Mulai" type="date" value={f.start_date} onChange={(e) => setF({ ...f, start_date: e.target.value })} data-testid="year-start-input" />
          <Field id="y-end" label="Selesai" type="date" value={f.end_date} onChange={(e) => setF({ ...f, end_date: e.target.value })} data-testid="year-end-input" />
        </FormCard>
      )}
      <ListState q={q} empty={{ title: "Belum ada tahun ajaran", description: "Buat tahun ajaran terlebih dahulu sebelum menambahkan kelas." }}>
        {(years) => years.map((y) => (
          <section key={y.id} className="rounded-2xl border bg-card p-5" data-testid={`year-${y.id}`}>
            <p className="font-bold">Tahun Ajaran {y.name}</p>
            <p className="text-xs text-muted-foreground">{fmtD(y.start_date)} s.d. {fmtD(y.end_date)}</p>
            {ss.err && <p className="text-sm text-[#E11D2E] mt-2" role="alert" data-testid={`sem-error-${y.id}`}>{ss.err}</p>}
            <ul className="mt-3 grid sm:grid-cols-2 gap-3">
              {["Ganjil", "Genap"].map((n) => {
                const ex = y.semesters.find((x) => x.name === n);
                const key = `${y.id}-${n}`;
                return (
                  <li key={n} className="rounded-lg bg-muted p-3 text-sm">
                    <p className="font-semibold">Semester {n}</p>
                    {ex ? <p className="text-xs">{fmtD(ex.start_date)} s.d. {fmtD(ex.end_date)}</p> : canManage ? (
                      <div className="flex flex-wrap gap-2 mt-2">
                        <input type="date" aria-label={`Mulai semester ${n}`} className="rounded border bg-background px-2 py-1 text-xs" onChange={(e) => setSemF(key, "start_date", e.target.value)} data-testid={`sem-start-${key}`} />
                        <input type="date" aria-label={`Selesai semester ${n}`} className="rounded border bg-background px-2 py-1 text-xs" onChange={(e) => setSemF(key, "end_date", e.target.value)} data-testid={`sem-end-${key}`} />
                        <button type="button" className="text-xs font-semibold text-[#3B82F6]" onClick={() => addSem(y, n)} data-testid={`sem-add-${key}`}>Tambahkan</button>
                      </div>
                    ) : <p className="text-xs text-muted-foreground">Belum diatur</p>}
                  </li>
                );
              })}
            </ul>
          </section>
        ))}
      </ListState>
    </div>
  );
};

export const SubjectsTab = ({ canManage }) => {
  const q = useList(`${AC}/subjects`);
  const s = useSubmit();
  const [f, setF] = useState({ code: "", name: "" });
  const add = () => s.run(() => post("/subjects", f), "Mata pelajaran ditambahkan.").then((ok) => ok && setF({ code: "", name: "" }));
  return (
    <div className="space-y-5">
      {canManage && (
        <FormCard title="Tambah mata pelajaran" onSubmit={add} busy={s.busy} err={s.err} submitLabel="Simpan" testId="subject-form">
          <Field id="s-code" label="Kode (contoh MAT)" value={f.code} onChange={(e) => setF({ ...f, code: e.target.value })} data-testid="subject-code-input" />
          <Field id="s-name" label="Nama mata pelajaran" value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} data-testid="subject-name-input" />
        </FormCard>
      )}
      <ListState q={q} empty={{ title: "Belum ada mata pelajaran" }}>
        {(rows) => (
          <ul className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3">
            {rows.map((r) => <li key={r.id} className="rounded-xl border bg-card p-4" data-testid={`subject-${r.id}`}><p className="font-mono text-xs text-muted-foreground">{r.code}</p><p className="font-semibold">{r.name}</p></li>)}
          </ul>
        )}
      </ListState>
    </div>
  );
};
